import { MouseEvent, ReactNode } from "react";
import { twMerge } from "tailwind-merge";

import {
  partBase,
  partActive,
  partHover,
  partFocus,
  partDisabled,
  partForceActive,
  partForceFocus,
} from "./class-names";
import { Checkbox } from "../checkbox";
import { Icon, IconName } from "../icon";
import { Switch } from "../switch";

export type DropdownPartProps = {
  id?: string;
  leftIcon?: IconName;
  rightIcon?: IconName;
  label?: string;
  labelOverride?: ReactNode;
  onClick?: (event: MouseEvent) => void;
  onMouseDown?: (event: MouseEvent) => void;
  onMouseEnter?: () => void;
  disabled?: boolean;
  active?: boolean;
  focused?: boolean;
  hidden?: boolean;
  toggled?: boolean;
  checked?: boolean;
  className?: string;
  indeterminate?: boolean;
};

export const DropdownPart = ({
  id,
  leftIcon,
  rightIcon,
  label,
  labelOverride,
  onClick,
  onMouseDown,
  onMouseEnter,
  disabled,
  active,
  focused,
  hidden,
  toggled,
  checked,
  className,
  indeterminate,
}: DropdownPartProps) => {
  const isToggleItem = toggled !== undefined;
  const isCheckboxItem = checked !== undefined;
  const isComponentItem = isCheckboxItem || isToggleItem;

  if (hidden) return null;

  return (
    <button
      className={twMerge(
        partBase,
        partActive,
        partHover,
        partFocus,
        disabled && partDisabled,
        active && partForceActive,
        focused && partForceFocus,
        className,
      )}
      onMouseEnter={onMouseEnter}
      onMouseDown={onMouseDown}
      onClick={(e) => {
        e.stopPropagation();
        if (onClick) onClick(e);
      }}
      onMouseUp={(e) => (e.target as HTMLButtonElement).blur()}
      onTouchEnd={(e) => (e.target as HTMLButtonElement).blur()}
      type="button"
      aria-label={label}
      disabled={disabled}
      id={id}
    >
      <div className="flex gap-small items-center w-full">
        {leftIcon && <Icon name={leftIcon} className="w-[1.6rem] h-[1.6rem]" />}
        {isToggleItem && (
          <Switch text={label} toggled={toggled} onClick={() => {}} />
        )}
        {isCheckboxItem && (
          <Checkbox
            label={label}
            checked={checked}
            indeterminate={indeterminate}
            onChange={() => {}}
            disabled={disabled}
          />
        )}
        {!isComponentItem && (
          <p className="text-ui text-left w-full">{labelOverride || label}</p>
        )}
      </div>
      {rightIcon && <Icon name={rightIcon} />}
    </button>
  );
};
